import { Editor } from 'tinymce';
import { TinyMCEExtensionBuilder } from '../JTinyMCEExtensions';
import { IntlShape } from 'react-intl';

export type TextGenerationCapabilities = {
    summarize: (text: string) => Promise<string>;
    develop: (text: string) => Promise<string>;
    tldr: (text: string) => Promise<string>;
    en: (text: string) => Promise<string>;
    es: (text: string) => Promise<string>;
    formal: (text: string) => Promise<string>;
    funny: (text: string) => Promise<string>;
};

export const JIATextGenerationExtension: TinyMCEExtensionBuilder<[TextGenerationCapabilities, IntlShape]> =
    function JIATextGenerationExtension(capabilities, intl) {
        return {
            setup: (editor) => {
                editor.ui.registry.addMenuButton('jia', {
                    fetch: (callback) => {
                        const execCapability = async (
                            editor: Editor,
                            capability: (text: string) => Promise<string>,
                        ) => {
                            try {
                                const selection = editor.selection;
                                const selectedText = selection.getContent();
                                const result = await capability(selectedText);
                                selection.setContent(result);
                            } catch (_) {
                                // nothing to do, a rejected promise means no text substitution
                                // must be done here
                            }
                        };
                        callback([
                            {
                                type: 'menuitem',
                                text: intl.formatMessage({ id: 'JIA_TINY_DEVELOP' }),
                                onAction: async function () {
                                    execCapability(editor, capabilities.develop);
                                },
                            },
                            {
                                type: 'menuitem',
                                text: intl.formatMessage({ id: 'JIA_TINY_SUMMARIZE' }),
                                onAction: function () {
                                    execCapability(editor, capabilities.summarize);
                                },
                            },
                            {
                                type: 'menuitem',
                                text: intl.formatMessage({ id: 'JIA_TINY_TLDR' }),
                                onAction: function () {
                                    execCapability(editor, capabilities.tldr);
                                },
                            },
                            {
                                type: 'menuitem',
                                text: intl.formatMessage({ id: 'JIA_TINY_EN_TRANSLATION' }),
                                onAction: function () {
                                    execCapability(editor, capabilities.en);
                                },
                            },
                            {
                                type: 'menuitem',
                                text: intl.formatMessage({ id: 'JIA_TINY_ES_TRANSLATION' }),
                                onAction: function () {
                                    execCapability(editor, capabilities.es);
                                },
                            },
                            {
                                type: 'menuitem',
                                text: intl.formatMessage({ id: 'JIA_TINY_FORMAL_TONE' }),
                                onAction: function () {
                                    execCapability(editor, capabilities.formal);
                                },
                            },
                            {
                                type: 'menuitem',
                                text: intl.formatMessage({ id: 'JIA_TINY_FUNNY_TONE' }),
                                onAction: function () {
                                    execCapability(editor, capabilities.funny);
                                },
                            },
                        ]);
                    },
                    icon: 'ai-prompt',
                    tooltip: intl.formatMessage({ id: 'JIA_TINY_BUTTON_TOOLTIP' }),
                });
            },
        };
    };
